<template>
  <div>
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="代理委托情况" />
        </div>
        <div class="section-content">
          <div v-if="bidEntrustStatusDict.translate(statusInfo.acceptStatus)">
            <jczh-descriptions
              :info="statusInfo"
              :option="entrustOptions"
              :el-attrs="{
                size: 'medium',
                labelStyle: {
                  whiteSpace: 'nowrap'
                }
              }"
            />
          </div>
          <el-tag v-else type="info">-</el-tag>
        </div>
      </div>
    </div>

    <div v-if="isRefused" class="card m-bottom">
      <div class="section">
        <div class="section-title">
          <base-section-title title="备注说明" />
        </div>
        <div class="section-content">
          <span class="text-danger">
            {{ statusInfo.rejectRemark || ' - ' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'

// 数据字典
import { bidEntrustStatusDict } from '@/dictionary/project/bid'

export default {
  name: 'ProcureAcceptStatus',

  components: {
    BaseSectionTitle
  },

  props: {
    statusInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      bidEntrustStatusDict // 采购方委托状态字典
    }
  },

  computed: {
    // 是否拒绝
    isRefused() {
      return (
        Number(this.statusInfo.acceptStatus) ===
        bidEntrustStatusDict.REFUSED.value
      )
    },

    entrustOptions() {
      return [
        { label: '委托时间', prop: 'publishTime' },
        {
          label: '委托状态',
          prop: 'acceptStatus',
          dictArray: bidEntrustStatusDict.array,
          useTag: true
        },
        {
          label: `委托${
            bidEntrustStatusDict.translate(this.statusInfo.acceptStatus)
              .titleLabel
          }时间`,
          prop: 'acceptTime',
          hideFun: value => {
            const arr = [
              bidEntrustStatusDict.ACCEPTED.value,
              bidEntrustStatusDict.REFUSED.value
            ]
            return !arr.includes(value)
          }
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.m-bottom {
  margin-bottom: $form-operation-height;
}
</style>
